import { Controller, useFormContext } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';

import { FormControl, FormLabel, InputGroup, Input, InputRightElement, Text, Skeleton, parseSafeFloat } from '@tradener/lumen';

import { useOffer } from '../context';

function VolumeInput() {
  const { quoteLoading } = useOffer();
  const { control, watch } = useFormContext();
  const { volumeType } = watch();

  return (
    <FormControl data-testid="modal-volume" display="flex" flexDirection="column" flex="1" gap="1.5">
      <FormLabel margin="0">Volume médio</FormLabel>
      <Skeleton isLoaded={!quoteLoading}>
        <InputGroup>
          <InputRightElement width="auto" color="gray.500" paddingInlineEnd="2.5" py="2" alignItems="flex-end">
            <Text textStyle="body1-regular">{volumeType}</Text>
          </InputRightElement>
          <Controller
            name="quoteItems.0.quantity"
            control={control}
            defaultValue={0.0}
            render={({ field: { onChange, ref, value, ...field } }) => (
              <NumericFormat
                customInput={Input}
                getInputRef={ref}
                placeholder="0,00"
                decimalScale={2}
                allowNegative={false}
                decimalSeparator=","
                fixedDecimalScale
                allowLeadingZeros
                py="2"
                paddingRight="2.5"
                paddingLeft="4"
                maxLength={12}
                value={value}
                color={value === 0.0 ? 'gray.500' : 'gray.900'}
                _focus={{ bgColor: 'gray.50', borderColor: 'brand.500' }}
                onValueChange={({ value }) => onChange(parseSafeFloat(value))}
                {...field}
              />
            )}
          />
        </InputGroup>
      </Skeleton>
    </FormControl>
  );
}

export default VolumeInput;
